// Client API of the multi-tenant package "ddpoa" (server: services/ddPoaContent.ts). The DD editor reads
// /api/due-diligence/settings, the POA form /api/poa/defaults; the public DD link carries the report part
// as `ddContent` in its own payload (routes/ddPublic.ts).
import { apiRequest } from '../api';

export type ZoningEntry = { t: string; h?: boolean; always?: boolean };
export type DdZoning = { mapImage: string; paragraphs: ZoningEntry[] };
export type DdServiceLink = { name: string; url: string };
/** What the report itself prints: the zoning map + essay and the firm's service links. */
export type DdContent = { zoning: DdZoning; services: DdServiceLink[] };
/** The editor's view: the report content plus who may be named as the site inspector. */
export type DdEditorSettings = DdContent & { inspectors: string[] };
export type Bi = { en: string; th: string };
// The POA form's own defaults. The setting still carries a `review` part — the three names the old
// free-text review lines were pre-filled with — but nothing reads it any more: the review is a
// recorded sign-off whose two checkers are the 'poa_signer' role (Admin → Roles), not a default.
// `attorneys` and `witnessList` are who the Property Form's POA card offers (report dc39d5a0); `donee` and
// `witnesses` stay who a blank box prints.
export type PoaAttorney = { name: Bi; birthDate: string; age: string; idNo: string; addr: Bi };
export type PoaDefaults = {
  madeAt: Bi;
  donee: { name: Bi; age: string; idNo: string; addr: Bi };
  witnesses: { name: Bi }[];
  attorneys: PoaAttorney[];
  witnessList: { name: Bi }[];
};
/** What the Property Form's POA card reads (GET /api/property-form/poa-people). Staff only: it holds ID numbers and home addresses. */
export type PoaPeople = Pick<PoaDefaults, 'madeAt' | 'donee' | 'witnesses' | 'attorneys' | 'witnessList'>;

export const ddPoaApi = {
  ddSettings: (): Promise<DdEditorSettings> => apiRequest('GET', '/due-diligence/settings'),
  poaDefaults: (): Promise<PoaDefaults> => apiRequest('GET', '/poa/defaults'),
  // administrators: everything, and a save of any of the four parts
  all: (): Promise<DdEditorSettings & { poaDefaults: PoaDefaults }> => apiRequest('GET', '/due-diligence/settings/all'),
  save: (d: Partial<DdEditorSettings & { poaDefaults: PoaDefaults }>): Promise<DdEditorSettings & { poaDefaults: PoaDefaults }> => apiRequest('PUT', '/due-diligence/settings', d),
};
